import { render, staticRenderFns } from "./RightSidebarComponent.vue?vue&type=template&id=0da13f81"
import script from "./RightSidebarComponent.vue?vue&type=script&lang=js"
export * from "./RightSidebarComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports